/**
 * @generated SignedSource<<f1ea175f89e6e947ae0fcdee540e373a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectCapabilitiesQuery$data = {
  readonly projects_capabilities_extension?: {
    readonly canCreateProject: boolean | null | undefined;
  } | null | undefined;
};
export type ProjectCapabilitiesQuery = {
  response: ProjectCapabilitiesQuery$data;
  variables: ProjectCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "containerId",
                "variableName": "containerId"
              }
            ],
            "concreteType": "TownsquareProjectAppCapabilities",
            "kind": "LinkedField",
            "name": "projects_capabilities_extension",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canCreateProject"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b1e026994ed1d01cfa8e9e8b03e0be04",
    "id": null,
    "metadata": {},
    "name": "ProjectCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7b137c737a75647644b46ac0deb6217e";

export default node;
